import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { SHARED_MASTERS_REGISTRY } from './sharedMastersRegistry';
import SharedListTable from './SharedListTable';
import AccountsSubNav from '../acheads/components/AccountsSubNav';
import InventorySubNav from '../inventory/components/InventorySubNav';

export default function SharedMasterPage() {
  const { module, masterId } = useParams();
  const rawId = masterId || module || '';
  const searchId = rawId.toLowerCase().trim();
  
  // Lookup config in registry
  const config = SHARED_MASTERS_REGISTRY[searchId];

  // Render 404 view if invalid module ID
  if (!config) {
    return (
      <div className="mx-auto flex w-full max-w-[1460px] flex-col items-center justify-center py-20 px-4">
        <div className="max-w-md w-full bg-surface-container-lowest border border-outline-variant/20 rounded-[2rem] p-8 shadow-lg text-center flex flex-col items-center">
          <div className="h-16 w-16 bg-error-container text-error rounded-full flex items-center justify-center mb-6 select-none">
            <span className="material-symbols-outlined text-3xl">warning</span>
          </div>
          <h2 className="text-2xl font-black text-on-surface mb-2">Master Module Not Found</h2>
          <p className="text-on-surface-variant text-sm mb-6 leading-relaxed">
            The requested module <code className="px-2 py-0.5 bg-surface-container-high text-error rounded font-mono">"{rawId}"</code> does not exist or has not been configured in the system master registry.
          </p>
          <Link 
            to="/dashboard/personal" 
            className="w-full bg-primary hover:opacity-90 text-on-primary font-bold py-3.5 px-4 rounded-xl transition-all shadow-md shadow-primary/20 focus:outline-none flex justify-center items-center"
          >
            Return to Dashboard
          </Link>
        </div>
      </div>
    );
  }

  // Get matching UI category & description metadata directly from the config registry
  const category = config.category || "Reference Registry";
  const desc = config.desc || `Configure and manage ${config.title.toLowerCase()} registries.`;
  const isAcHeadsRelated = ['ac-groups', 'ac-group', 'customergroup', 'customer-group', 'groups', 'group'].includes(searchId);
  const isInventoryRelated = ['inventory-group', 'inventory-groups'].includes(searchId);

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-7 pb-8 px-4 sm:px-6">
      
      {/* Dynamic Header Block */}
      <section className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between border-b border-outline-variant/10 pb-5">
        <div>
          <p className="text-xs font-black uppercase tracking-[0.16em] text-primary">{category}</p>
          <h1 className="mt-1 font-display text-3xl font-extrabold tracking-tight text-on-surface">
            {config.title}
          </h1>
          <p className="mt-2 text-sm text-on-surface-variant max-w-xl leading-relaxed">
            {desc}
          </p>
        </div>

        {isAcHeadsRelated && <AccountsSubNav />}
        {isInventoryRelated && <InventorySubNav />}
      </section>

      {/* Reusable Data Table Component */}
      <section className="mt-2">
        <SharedListTable config={config} />
      </section>

    </div>
  );
}
